import { render } from "./AddFormElement.vue?vue&type=template&id=6a28a142&scoped=true"
import script from "./AddFormElement.vue?vue&type=script&lang=js"
export * from "./AddFormElement.vue?vue&type=script&lang=js"

import "./AddFormElement.vue?vue&type=style&index=0&id=6a28a142&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a28a142"]])

export default __exports__